@if (showTrigger()) {
  <se-fe-modal-button [seFeDataButton]="{icon: true}" (seFeButtonAction)="open($event)">
    <se-fe-icon
      seFeModalIcon
      seFeDataName="edit"
      seFeDataSize="500"
      seFeDataColor="default"
      seFeDataAriaLabel="Edit variant inventory"></se-fe-icon>
  </se-fe-modal-button>
}

<se-fe-modal seFeDataSize="large" #inventoryModal (seFeAfterClose)="reset()">
  <div seFeModalHeader>
    <div class="inventory-modal-header">
      <h2 id="inventory-modal-title" class="se-fe-modal__title inventory-modal-title">
        Edit Product Variant Inventory
      </h2>
      <se-fe-icon-button (click)="close()">
        <se-fe-icon
          seFeDataName="remove"
          seFeDataSize="500"
          seFeDataColor="default"
          seFeDataAriaLabel="Close"></se-fe-icon>
      </se-fe-icon-button>
    </div>
  </div>

  <se-fe-modal-content>
    @if (inventoryModal.isOpen || inventoryModal.closing) {
      <form [formGroup]="form" [attr.aria-busy]="saving()" novalidate>
        <se-fe-table-wrapper>
          <table seFeTable title="Product variant inventory" [dataSource]="inventoryDatasource">
            <ng-container seFeColumnDef="name">
              <th seFeHeaderCell *seFeHeaderCellDef>Variant</th>
              <td seFeCell *seFeCellDef="let row" class="variant-name">{{ row.name }}</td>
            </ng-container>
            <ng-container seFeColumnDef="quantityAvailable">
              <th seFeHeaderCell *seFeHeaderCellDef>Quantity available</th>
              <td seFeCell *seFeCellDef="let row" class="quantity-available">
                {{ row.inventory ?? 'Unlimited' }}
              </td>
            </ng-container>
            <ng-container seFeColumnDef="inventory">
              <th seFeHeaderCell *seFeHeaderCellDef>
                <span class="adjust-by-header">
                  Adjust by
                  <se-fe-icon-button [seFeTooltipTrigger]="adjustByTooltip">
                    <se-fe-icon
                      seFeDataName="question_circle"
                      seFeDataSize="400"
                      seFeDataColor="blue"
                      seFeDataAriaLabel="About adjusting inventory"></se-fe-icon>
                  </se-fe-icon-button>
                </span>
                <se-fe-tooltip #adjustByTooltip>
                  Current total quantity will be adjusted by the number entered.
                </se-fe-tooltip>
              </th>
              <td seFeCell *seFeCellDef="let row">
                <se-fe-form-field [seFeDataConfig]="inventoryConfig" class="inventory-field">
                  <se-fe-form-field-quantity
                    [formControlName]="'' + row.id"
                    [seFeDataMin]="inventoryMin"
                    [seFeEnableManualInput]="true"></se-fe-form-field-quantity>
                </se-fe-form-field>
              </td>
            </ng-container>
            <tr seFeHeaderRow *seFeHeaderRowDef="tableColumns"></tr>
            <tr seFeRow *seFeRowDef="let row; columns: tableColumns"></tr>
          </table>
        </se-fe-table-wrapper>
      </form>

      <se-fe-banner
        class="inventory-help"
        [seFeDataTitle]="'How product inventory works'"
        [seFeShowIcon]="true"
        seFeDataIconName="info_circle">
        <div seFeBannerSubtitle
          >When you sell products, the number sold will automatically be removed from the quantity available. You can
          make adjustments to the quantity available if you get more in stock or if you have to remove some from your
          available stock.</div
        >
      </se-fe-banner>

      @if (saveError()) {
        <se-fe-alert seFeDataType="error">{{ saveError() }}</se-fe-alert>
      }

      <div class="inventory-modal-footer">
        <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="saving()" (click)="close()">Cancel</se-fe-button>
        <se-fe-button
          seFeDataEmphasis="high"
          [seFeDataIsLoading]="saving()"
          seFeDataLoadingLabel="Saving inventory"
          (click)="save()"
          >Save</se-fe-button
        >
      </div>
    }
  </se-fe-modal-content>
</se-fe-modal>

<se-fe-modal #discardChangesModal [seFeDataActions]="discardChangesModalButtons">
  <div seFeModalContent>
    <h3>Discard unsaved changes?</h3>
    <p>You have unsaved changes. Are you sure you want to discard them?</p>
  </div>
</se-fe-modal>

<se-fe-modal
  #inventoryConflictModal
  seFeDataTitle="Inventory changed"
  (seFeClose)="clearInventoryConflicts()"
  (seFeAfterClose)="currentConflict.set(null)">
  <div seFeModalContent>
    <div aria-live="polite" aria-atomic="true">
      @if (currentConflict(); as conflict) {
        <h3>Quantity changed for {{ conflict.variant.name || 'Variant ' + conflict.variant.id }}</h3>
        <p>
          The quantity available for this variant changed from {{ formatInventory(conflict.originalInventory) }} to
          {{ formatInventory(conflict.variant.inventory ?? null) }} while the Edit Variant Inventory modal was open.
          Choose the quantity to save for this variant.
        </p>
      }
    </div>
    @if (currentConflict(); as conflict) {
      <div class="inventory-conflict-actions">
        <se-fe-button
          seFeDataEmphasis="low"
          [seFeDataIsDisabled]="saving() || reviewCompleting()"
          (click)="cancelInventoryConflicts()"
          >Cancel</se-fe-button
        >
        <se-fe-button
          seFeDataEmphasis="medium"
          [seFeDataIsDisabled]="saving() || reviewCompleting()"
          (click)="chooseInventoryConflict(false, conflict.variant.id, $event)">
          {{ inventoryConflictModalButtons[1].label }}
        </se-fe-button>
        <se-fe-button
          seFeDataEmphasis="medium"
          [seFeDataIsDisabled]="saving() || reviewCompleting()"
          (click)="chooseInventoryConflict(true, conflict.variant.id, $event)">
          {{ inventoryConflictModalButtons[2].label }}
        </se-fe-button>
      </div>
    }
  </div>
</se-fe-modal>
